module.exports = __webpack_public_path__ + "img/sg-logo-big.cb338619.png";